import groq from 'groq';

import { ASSET, RICH_TEXT } from '../common';
import { PRODUCT_SLUG } from '../product';
import { CONSUMER_TRIAL } from './consumerTrials';
import { QUOTE } from './quote';

export const BEFORE_AFTER = groq`
  results[] {
    "isOverlineVisible": coalesce(isOverlineVisible, true),
    clinicalFactTitle,
    clinicalResultSubtitle[] {
      ${RICH_TEXT}
    },
    "product": product -> { ${PRODUCT_SLUG} },
    quoteOrConsumerTrial[] -> {
      ...,
      _type,
      _type == 'timeline_quote' => {
        ${QUOTE}
      },
      _type == 'timeline_consumerTrial' => {
        _type,
        ${CONSUMER_TRIAL}
      }
    },
    before {
      image {
        ${ASSET}
      },
      imageOverlay {
        ${ASSET}
      },
      caption
    },
    after {
      image {
        ${ASSET}
      },
      imageOverlay {
        ${ASSET}
      },
      caption
    }
  },
  "productFormatSlugs": ^.^.productFormats->products[].product->store.slug.current
`;

export const BEFORE_AFTER_BLOCK = groq`
  _type == 'beforeAfter' => @-> {
    ${BEFORE_AFTER}
  }
`;
